import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './header.intl.json';

export const useHeaderIntl = () => useIntlModule(messages);
